import { Email } from '@material-ui/icons'

import React from 'react'

export const SOCIAL_LINKS = {
  email: {
    name: 'email',
    link: 'mailto:hi at flvyu dot com',
    message: 'Contact Me',
    icon: <Email />,
  },
}
